import * as React from 'react';
import { SVGProps } from 'react';

const SvgVisitorLounge = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5 9.167V7.5C19.5 6.125 18.375 5 17 5H7a2.507 2.507 0 0 0-2.5 2.5v1.667a2.507 2.507 0 0 0-2.5 2.5v4.167c0 1.375 1.125 2.5 2.5 2.5h15c1.375 0 2.5-1.125 2.5-2.5v-4.167c0-1.375-1.125-2.5-2.5-2.5zM6.167 7.5c0-.458.375-.833.833-.833h10c.458 0 .833.375.833.833v2.317a2.49 2.49 0 0 0-.833 1.85v1.667H7v-1.667a2.49 2.49 0 0 0-.833-1.85V7.5zm14.166 8.333a.836.836 0 0 1-.833.833h-15a.836.836 0 0 1-.833-.833v-4.167c0-.458.375-.833.833-.833s.833.375.833.833v3.333h13.333v-3.333c0-.458.375-.833.833-.833s.833.375.833.833v4.167z" />
  </svg>
);

export default SvgVisitorLounge;
